import { healthScore } from 'happ-preloaded-data/data';
import axiosClient from 'happ-config/axios';

const getHealthScore = async (token) => {

    if (token !== null) {
        try {
            const headers = {'Content-Type': 'application/json'};
            const response = await axiosClient.get(`/patients/getScore/${token}`,{
                headers: headers
            });
            return response
        } catch (error) {
            const {response} = error;
            return response;
        }
    }
}

export {
    getHealthScore
}